import FormConfig from "../formConfig.js";
import { fun_PostAction } from "@/api/index";
// 引入包内容组件
import Package from "./components/index.vue";
export default {
  data() {
    return {
      // 列表loading状态
      loading: false,
      // 表单对象
      form: {
        id: null, // 主键
        processName: null, // 流程名称
        processCode: null, // 流程编号
        userType: null, // 用户类型
        constructionNo: null, // 是否报建类
        applicationNo: null, // 是否目录内
        tenderMethodNo: null, // 招标组织形式
        tenderTypeNumNo: null, // 招标方式
        isUnionTenderNo: null, // 是否联合体招标
        isUnionCorpEnrollNo: null, // 是否允许投标单位为联合体
        prequalificationTypeNo: null, // 资格审查方式
        constructionIdNo: null, // 报建项目
        agencyCorpRecordNo: null, // 招标代理备案项目
        oldFlagNo: null, // 国产化项目
      },
      // 表单错误
      errRules: {
        id: null, // 主键
        processName: null, // 流程名称
        processCode: null, // 流程编号
      },
      // 表单配置
      formConfigList: FormConfig.configList(),
      controllerFlg: null,// 操作标志
      id: null,  // 主键
    };
  },
  // 注册组件
  components: {
    Package,
  },
  // 模板编译完成
  mounted() {
    // 打开loading
    this.loading = true;
    // 操作标志
    this.controllerFlg = this.$route.query.type;
    // 主键
    this.id = this.$route.query.id;

    // 如果是详情
    if (this.controllerFlg == "details") {
      // 获取详情信息
      this.fun_Details();
      // 清空表头
      this.$refs.Package.btnList = [];
      // 遍历表单
      this.formConfigList.map(e => {
        // 遍历
        e.formConfigList.map(form => {
          // 不可编辑
          form.disabled = true;
        });
      });
    }
    // 如果是修改
    else if (this.controllerFlg == "update") {
      // 获取详情信息
      this.fun_Details();
    }
  },
  // 自定义方法
  methods: {
    /**
     * @description 详情
     * @author
     */
    fun_Details() {
      // 请求，获取结果集
      fun_PostAction("/allProcessSet/detail", {
        id: this.id
      }).then(res => {
        // 解构res.data
        const { result, data } = res.data;
        // 判断请求是否成功
        if (result) {
          // 数据回显
          this.form = data.data;
          // 流程明细
          this.$refs.Package.tableData = data.list;

          // 关闭loading
          this.loading = false;
        }
      });
    },
    /**
     * 下拉框值改变事件
     * @author shuhua
     */
    fun_GetSelectVal(e, i) {
      // 赋值
      this.form[i] = e;
    },
    /**
     * @description 保存或修改
     * @author
     */
    fun_SaveOrUpdate() {
      // 遍历错误消息
      for (let i in this.errRules) {
        // 设置为空
        this.errRules[i] = null;
      }
      // 表单验证
      this.$refs.collapseForm.$refs.enInform.validate(valid => {
        // 验证通过
        if (valid) {
          // 如果监管流程节点为空
          if (this.$refs.Package.tableData.length == 0){
            // 请求失败，弹出失败msg的消息提示
            this.$message.error("请至少添加一条流程设定详情！");
            return false;
          }
          // 请求
          fun_PostAction("/allProcessSet/saveOrUpdate", {
            ...this.form, // form表单数据
            controllerFlg: this.controllerFlg, // 操作标志
            list: JSON.stringify(this.$refs.Package.tableData),
          }).then(res => {
            // 解构res.data
            const { result, data, msg } = res.data;
            // 解析后台返回的结果集，判断是否成功
            if (result) {
              // 操作成功
              this.$message.success(msg);
              // 返回一览
              this.fun_Back();
            } else {
              // 如果页面验证失败
              if (data != null && data != "") {
                // 返回错误消息
                this.errRules = data;
                // 请求失败，弹出失败msg的消息提示
                this.$message.error("您输入的数据存在错误！");
              } else {
                // 请求失败，弹出失败msg的消息提示
                this.$message.error(msg);
              }
            }
            // 关闭loading
            this.loading = false;
          });
        } else {
          // 关闭loading
          this.loading = false;
          // 提示
          this.$alert("页面存在错误信息，请检查后重试！", "warning");
          return false;
        }
      });
    },
    /**
     * 返回的方法
     * @author shuhua
     */
    fun_Back() {
      // 返回
      this.$router.back();
    }
  }
};
